import { Call } from '@mui/icons-material'
import BaseStatusIcon from '../BaseStatusIcon'

const CallActiveIcon = () => {
  return <BaseStatusIcon title='Call is active' icon={Call} />
}

export default CallActiveIcon
